import React from 'react';
import { Link } from 'react-router';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog, IconButton } from 'react-toolbox';
import { addFlagToPhase } from 'actionCreators/phase';
import { clearValidation, updatePhaseTask } from 'actionCreators';
import { getPhaseErrors } from '../../../../../../reducers';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import ColoredButton from 'components/ColoredButton';
import RadioButtons from 'components/RadioButtons';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import inputStyles from 'styles/input.scss';

class MaterialsRequestedModal extends Resetter(Validator(React.Component)) {
  // Since chargebacks aren't determined by the state in the form, we're
  // setting whether the chargeback is present or not in state here for validation
  componentDidUpdate = (prevProps) => {
    if (prevProps.chargebackPresent !== this.props.chargebackPresent) {
      this.setState({ chargebackPresent: this.props.chargebackPresent });
    }
  }

  static DEFAULT_STATE = {
    note: '',
    errors: {},
    sendError: false,
    isLar: 'no',
    chargebackPresent: false,
    chargebackError: false,
  }
  static VALIDATIONS = { note: 'This field is required' }
  static OPTIONS = [
    { label: 'No', value: 'no' },
    { label: 'Yes', value: 'yes' },
  ];

  handleClose(reload = true) {
    super.handleClose();
    this.props.clearValidation();
    if (reload) document.location.reload();
  }

  handleNoteChange = e => this.setState({ note: e.target.value });

  data = () => ({ event: { data: { note: this.state.note } } });

  handleSubmit = () => {
    let cbError = false;
    if (!this.props.chargebackPresent) {
      this.setState({ chargebackError: true });
      cbError = true;
    } else this.setState({ chargebackError: false });
    if (!this.validate() || cbError === true) return;
    this.addFlagIfLar();
    this.phaseTaskUpdate();
  }

  addFlagIfLar = () => {
    if (this.state.isLar === 'yes') {
      const flagProps = {
        name: 'Materials Requested',
        note: this.state.note,
      };
      this.props.addFlagToPhase(this.props.phase.id, flagProps)
        .catch(result => this.setState({ sendError: true, errors: result.payload.errors }));
    }
  }

  phaseTaskUpdate = () => {
    const task = { status: 'complete' };
    const data = this.data();
    this.props.updatePhaseTask(
      this.props.phase.id,
      this.props.task.slug,
      { task, ...data },
    )
      .then(() => this.handleClose())
      .catch(result => this.setState({
        sendError: true, errors: result.payload.errors,
      }));
  }

  handleIsLarChange = e => this.setState({ isLar: e });

  render() {
    const { note, errors, isLar, chargebackError } = this.state;
    const { phase, active } = this.props;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Materials Requested</h5>
      <RadioButtons
        text="Is an LAR purchase required?"
        required
        selectedValue={isLar}
        onChange={this.handleIsLarChange}
        radioButtons={MaterialsRequestedModal.OPTIONS}
      />
      <TextArea
        label="Notes"
        value={note}
        errors={errors.note}
        onChange={this.handleNoteChange}
      />
      {chargebackError && <div className={inputStyles.errored}>
        <div className={inputStyles.chargebackError}>
          A chargeback must be added before this task can be complete.
          Add chargeback <Link
            to={`/phases/${phase.id}/labor-product-accounting/chargeback`}
            onClick={() => this.handleClose(false)}
          >Here</Link>
        </div>
      </div>}
      <div className={S.actions}>
        <ColoredButton
          color="green"
          responsive
          label="Complete Task"
          className={S.button}
          onClick={this.handleSubmit}
        />
        <ColoredButton
          color="darkGray"
          responsive
          label="Cancel"
          className={S.button}
          onClick={this.handleClose}
        />
      </div>
    </Dialog>);
  }
}

MaterialsRequestedModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  addFlagToPhase: PropTypes.func.isRequired,
};

MaterialsRequestedModal.defaultProps = { active: false };

export default connect(state => ({ errors: getPhaseErrors(state) }), {
  clearValidation,
  updatePhaseTask,
  addFlagToPhase,
})(MaterialsRequestedModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/materialsRequestedModal.jsx